// extracted by mini-css-extract-plugin
export default {"tooltip":"un-z","sharingV2":"vn-z","sharingIconsV2":"wn-z","links":"xn-z","link":"yn-z","facebookV2":"zn-z","twitterV2":"An-z","pinterestV2":"Bn-z"};